import ApiServices from "@/services/ApiServices";

export default {
  data: function () {
    return {
      metaOptions: null,
    };
  },
  methods: {
    getItemOptions(path, paramstring = "") {
      ApiServices.genericApiCall(path, paramstring) // admin = true
        .then((response) => {
          this.metaOptions = response.data;
        })
        .catch((error) => {
          console.log("error", error);
          if (error)
            this.error = "An API error occurred whilst getting item options";
        })
        .finally(() => {});
    },
  },
};
